import React, { useEffect, useState } from 'react'
import './GuestComments.scss';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { format } from 'date-fns';
import moment from 'moment';
import styled from '@emotion/styled';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { CircularProgress, Switch } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import { Button, FormGroup, Label} from "reactstrap";
import { useSelector, useDispatch } from 'react-redux';
import {stableSort, rowOptions, downloadExcel} from '../../../utils/Helper'
import {getGuestComments} from '../../../redux/actions/ReportAction/GuestCommentsAction/GuestCommentsAction'
import DatePicker from '../../../components/DatePicker/DatePicker';
import {ReactComponent as DownloadIcon} from "../../../assets/images/CommonComponent/downloads.svg"
import { tabKeys } from '../../../Config/Constant';


const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const descendingComparator = (a, b, orderBy) => {
    if(typeof a[orderBy] === 'string' && typeof b[orderBy] === 'string'){
        if (b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase()) {
          return -1;
        }
        if (b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase()) {
          return 1;
        }
    }else{
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
        return 1;
        }
    }
    return 0;
  }

const getComparator = (order, orderBy) => {
    if (orderBy === "duration") orderBy = "durationOne"
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        id: 'guest_name',
        disablePadding: false,
        label: 'GUEST NAME',
        width: '150px'
    },
    {
        id: 'check_out',
        disablePadding: false,
        label: 'CHECK OUT',
        width: '150px'
    },
    {
        id: 'highlights_of_experience',
        disablePadding: false,
        label: 'WHAT ARE THE HIGHLIGHTS OF YOUR ANANDA EXPERIENCE',
        width: '300px'
    },
    {
        id: 'improvement',
        disablePadding: false,
        label: 'WHAT COULD WE DO TO IMPROVE YOUR WELLNESS EXPERIENCE',
        width: '300px'
    },
    {
        id: 'therapists_recognised',
        disablePadding: false,
        label: 'THERAPISTS RECOGNISED',
        width: '300px'
    },
    {
        id: 'service_staff_recognised',
        disablePadding: false,
        label: 'SERVICE STAFF RECOGNISED',
        width: '300px'
    },
    
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                (<TableCell
                    key={headCell.id}
                    align='left'
                    sx={{minWidth: headCell.width}}
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                >
                    <TableSortLabel
                        
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.id === 'action' ? true : false}
                    >
                        <div style={{textAlign: "left"}}>
                            {headCell.label}
                        </div>
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { activeTab, setShowLoader } = props;
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [fromDate, setFromDate] = useState(searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"));
    const [toDate, setToDate] = useState(searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"));
    const {downloadLoader} = useSelector(state => state?.guestComments);

    useEffect(() => {
        if (activeTab == tabKeys.reports.GUEST_COMMENTS) {
            setFromDate(searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"));
            setToDate(searchParams.get('filter_to') || format(new Date(), "yyyy-MM-dd"));
        }
    }, [activeTab, searchParams]);


    const changeFromDate = (val) => {
        setShowLoader(true)
        const formattedDate = format(val, "yyyy-MM-dd");
        setFromDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate && formattedDate !== format(new Date(), "yyyy-MM-01")) {
            newParams.set('filter_from', formattedDate);
        } else {
            newParams.delete('filter_from');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeToDate = (val) => {
        setShowLoader(true)
        const formattedDate = format(val, "yyyy-MM-dd");
        setToDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate && formattedDate !== format(new Date(), "yyyy-MM-dd")) {
            newParams.set('filter_to', formattedDate);
        } else {
            newParams.delete('filter_to');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }

    const downloadTableData = ()=>{
        const onSuccessCallback = (data)=>{
            downloadExcel({data, fileName: `Guest Comments - ${format(new Date(fromDate), 'dd-MM-yyyy')} to ${format(new Date(toDate), 'dd-MM-yyyy')}.xlsx`})
        }

        const sendRequest = {
            downloadExcel: true,
            "pageNo": searchParams.get('page') || 1,
            "filter_from": searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"),
            "filter_to": searchParams.get('filter_to') || (format(new Date(), "yyyy-MM-dd") === format(new Date(), "yyyy-MM-01") ? '' : format(new Date(), "yyyy-MM-dd")),
            onSuccessCallback
        };
        dispatch(getGuestComments(sendRequest));
    }

    return (
        <>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Guest Comments
                    </MainHeading>
                </div>
                <div className='col-9 LevelDiv'>
                    <div className='DurationDiv d-flex align-items-center'>
                        <Label>Date:</Label>
                        <DatePicker
                            onChange={date => { changeFromDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={new Date(moment(fromDate, "YYYY-MM-DD").format('MM-DD-YYYY'))}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                        <div className='mx-2'>to</div>
                        <DatePicker
                            onChange={date => { changeToDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={new Date(moment(toDate, "YYYY-MM-DD").format('MM-DD-YYYY'))}
                            minDate={new Date((moment(fromDate, "YYYY-MM-DD").add(1, 'days')).format('MM-DD-YYYY'))}
                            maxDate={new Date()}
                            popperPlacement={"bottom"}
                            width={'140px'}
                            height={'48px'}
                        />
                        <div className="separator mx-3"></div>
                        <Button className="btn btn-primary download-btn " disabled={downloadLoader} type="submit" onClick={downloadTableData}>
                            <span className="btn-icon">
                                {
                                    !downloadLoader ?
                                    <>
                                        <DownloadIcon fontSize={'17px'} className='mr-1' /> 
                                    </>
                                    :
                                    <CircularProgress size={13} className='mt-1 mr-1' sx={{color: 'white'}} />
                                }
                            </span>
                            Download Excel
                        </Button>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </>
    );
}

const GuestCommentsTable = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type') || 'asc');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || 'name');
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [viewGuestComments, setViewGuestComments] = useState('');
    const viewGuestCommentsList = useSelector(state => state?.guestComments);
    const viewGuestCommentsListDataRes = useSelector(state => state?.guestComments?.guestComments);
    const [showLoader, setShowLoader] = useState(false);

    const { permission, activeTab } = props;
    const dispatch = useDispatch();



    useEffect(() => {
        if (activeTab == tabKeys.reports.GUEST_COMMENTS) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_text": searchParams.get('filter_text') || '' ,
                "filter_from": searchParams.get('filter_from') || format(new Date(), "yyyy-MM-01"),
                "filter_to": searchParams.get('filter_to') || (format(new Date(), "yyyy-MM-dd") === format(new Date(), "yyyy-MM-01") ? '' : format(new Date(), "yyyy-MM-dd")),
                "order": searchParams.get('order_by_type') || 'asc',
                "orderBy": searchParams.get('order_by') || 'name'
            };
            dispatch(getGuestComments(sendRequest));
        }else{
          setOrder( '');
          setOrderBy('');
          setRowsPerPage(10)
        }

    }, [activeTab, searchParams]);
    
    useEffect(() => {
        if (viewGuestCommentsList.error !== "Ananda guestcomments data does not exists") {
            setViewGuestComments(viewGuestCommentsListDataRes && viewGuestCommentsListDataRes);
        } else {
            setViewGuestComments('');
        }

    }, [viewGuestCommentsListDataRes, viewGuestCommentsList])

    useEffect(()=>{
        if(!viewGuestCommentsList.loading)
            setShowLoader(false)
        if(!viewGuestCommentsList.loading && !viewGuestCommentsListDataRes.length && !viewGuestCommentsList.error){
            setShowLoader(true)
        }
    }, [viewGuestCommentsList.loading])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        if (property) {
            newParams.set('order_by', property);
        } else {
            newParams.delete('order_by');
        }
        newParams.set('order_by_type', newOrder);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewGuestCommentsListDataRes && viewGuestComments.map((n) => n?.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const handleChangePageNext = (newPage) => {
        setShowLoader(true)
        const nextPage = (viewGuestCommentsListDataRes?.data?.current_page_no || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    
    const handleChangePagePrev = (newPage) => {
        setShowLoader(true)
        const prevPage = (viewGuestCommentsListDataRes?.data?.current_page_no || 2) - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true)
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('limit', newRowsPerPage.toString());
        } else {
            newParams.delete('limit');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };

    


    return (
        <div className="ProBox">
            <Box sx={{ width: '100%', height: 'calc(100vh - 200px)' }} className="GuestCommentsBox">
            <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 2, borderRadius: 2, height: '100%' }}>
                    <EnhancedTableToolbar 
                        setShowLoader={setShowLoader}
                        showLoader={viewGuestCommentsList.loading}
                        activeTab ={activeTab} />
                {
                    showLoader ?
                    <div className='w-100 text-center py-5'>
                        <CircularProgress sx={{'color': '#74613C'}}/>
                    </div>
                    :
                    <>
                        
                        {!!viewGuestComments?.length ? <TableContainer sx={{ minHeight: 'calc(100% - 85px)', maxHeight: 'calc(100% - 85px)' }}>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                stickyHeader
                                size='small'
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={viewGuestCommentsListDataRes && viewGuestComments?.length}
                                />
                                <TableBody>
                                    {
                                        viewGuestCommentsListDataRes && stableSort(viewGuestComments, getComparator(order, orderBy))
                                            .map((row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"

                                                            tabIndex={-1}
                                                            key={index}

                                                            >
                                                            <TableCell align="left">{row.guest_name}</TableCell>
                                                            <TableCell align="left">{moment(row.check_out)?.format('DD/MM/YYYY')}</TableCell>
                                                            <TableCell align="left">{row.highlights_of_experience} </TableCell>
                                                            <TableCell align="left">{row.improvement}</TableCell>
                                                            <TableCell align="left">{row.therapists_recognised}</TableCell>
                                                            <TableCell align="left">{row.service_staff_recognised}</TableCell>
                                                        </TableRow>
                                                        
                                                    </React.Fragment>
                                                );
                                            })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                         : <div className='text-center w-100 text-muted mt-3'>No Records</div>}
                    </>
                }
                </Paper>
                {/* {
                    viewGuestComments
                    &&
                    <div className='paginationBlock'>
                        <div className='textData'><p>Items per page: </p></div>
                        <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                            <Select
                                placeholder={rowsPerPage}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={rowsPerPage}
                                options={rowOptions}
                                isSearchable={false}
                                onChange={handleChangeRowsPerPage}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                                menuPlacement="top"
                                menuPosition="fixed"
                                styles={{
                                    menu: (base) => ({
                                        ...base,
                                        top: 'auto',
                                        bottom: 0,
                                    }),
                                }}
                            />
                        </FormGroup>
                        {viewGuestCommentsListDataRes?.data && <p className='endText'>   {viewGuestCommentsListDataRes?.data?.start} - {viewGuestCommentsListDataRes?.data?.end} of {viewGuestCommentsListDataRes?.data?.total}</p>}
                        <p>
                            <button className={btnPrev.join(' ')} onClick={() => { handleChangePagePrev(page) }}>
                                <ArrowBackIosNewSharpIcon className='iconBtn' />
                            </button>
                            <button className={btnNext.join(' ')} onClick={() => { handleChangePageNext(page) }}>
                                <ArrowForwardIosSharpIcon className='iconBtn' />
                            </button></p>
                    </div>   
                } */}
            </Box>
        </div>
    );
}
export default GuestCommentsTable;